module.exports = __webpack_public_path__ + "img/app-code.b799d76.png";